module.exports = __webpack_public_path__ + "profileicon.9d031c34.svg";